import React, { lazy } from "react";
import { useRoutes } from "react-router";
import Loadable from "../view/common/component/Loadable";
import Privacy from "../view/common/component/Privacy";

const MainLayout = Loadable(lazy(() => import('../layout/MainLayout')));
const ProductLists = Loadable(lazy(() => import('../view/common/ProductLists')));
const ProductDetails = Loadable(lazy(() => import('../view/common/ProductDetails')));
const Profile = Loadable(lazy(() => import('../view/common/Profile')));
const Messages = Loadable(lazy(() => import('../view/common/Messages')));
const Subscription = Loadable(lazy(() => import('../view/seller/Subscription')));
const MinimalLayout = Loadable(lazy(() => import('../layout/MinimalLayout')));
const Landing = Loadable(lazy(() => import('../view/common/Landing')));
const About = Loadable(lazy(() => import('../view/common/About')));
const Favorites = Loadable(lazy(() => import('../view/seller/Favorites')));
const ServiceProviderCategoryList = Loadable(lazy(() => import('../view/Provider/CategoryList')));
const AllServiceProviders = Loadable(lazy(() => import('../view/Provider/AllServiceProviders')));

export default function BuyerRoutes() {

  const list = {
    children: [
      { path: '/', element: <MinimalLayout> <Landing/> </MinimalLayout>},
      { path: '/about', element: <MinimalLayout> <About/> </MinimalLayout>},
      { path: '/product-list', element: <MainLayout> <ProductLists /> </MainLayout> },
      { path: '/product-details/:id', element: <MainLayout> <ProductDetails /> </MainLayout> },
      { path: '/profile', element: <MainLayout> <Profile /> </MainLayout> },
      { path: '/chat', element: <MainLayout> <Messages /> </MainLayout> },
      { path: '/subscription', element: <MainLayout> <Subscription /> </MainLayout> },
      { path: '/favorites', element: <MainLayout> <Favorites /> </MainLayout> },
      { path: '/privacy', element: <MinimalLayout> <Privacy/> </MinimalLayout>},
      { path: '/service-provider/service-list', element: <MainLayout> <ServiceProviderCategoryList/> </MainLayout> },
      { path: '/service-provider/all-service-providers', element: <MainLayout> <AllServiceProviders/> </MainLayout> },
      { path: '*', element: <MinimalLayout> <Landing/> </MinimalLayout> }
    ],
  };
  return useRoutes([list]);
}
